import React, { useContext } from 'react'
import {MdClose} from "react-icons/md"
import {BsCartX} from "react-icons/bs"
import "./cart.css"
import CartItem from './CartItem/CartItem'
import { Context } from '../../utils/context'
import { useNavigate } from 'react-router-dom'

function Cart(props: any) {
  const {cartItems, cartSubTotal} = useContext(Context)
  const navigate = useNavigate();

  return (
    <div className='cart-panel'>
      <div className="opac-layer" onClick={() => props.setShowCart(false)}></div>
      <div className="cart-content">
        <div className="cart-header">
          <span className="cart-heading">Shopping Cart</span>
          <span className="cart-close-btn" onClick={() => props.setShowCart(false)}>
            <MdClose />
            <span className="cart-text">close</span>
          </span>
        </div>

        {!cartItems?.length && <div className="empty-cart">
          <BsCartX />
          <span>Add Products in the Cart.</span>
          <button className='return-cta' onClick={() => props.setShowCart(false)}>RETURN TO THE SHOP</button>
        </div>}
        {!!cartItems?.length && <>
          <CartItem />
          <div className="cart-footer">
            <div className="subtotal">
              <span className="cart-footer-text">Subtotal:</span>
              <span className="cart-footer-text cart-total">&#8377;{cartSubTotal}</span>
            </div>
            <div className="cart-btn">
              <button className="cart-checkout-btn" onClick={() => navigate("/review")}>Checkout</button>
            </div>
          </div>
        </>}
      </div>
    </div>
  )
}

export default Cart
